import React, { useEffect, useRef, useState } from "react";
import "./FilterStatusSelect.scss";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";

const statusOptions = [
  { value: "cancelled", label: "Cancelled" },
  { value: "completed", label: "Completed" },
  { value: "draft", label: "Draft" },
  { value: "processing", label: "Processing" },
  { value: "scheduled for Post", label: "Scheduled for Post" },
  { value: "errored!", label: "Errored!" },
];

const FilterStatusSelect = ({ formik }: { formik: any }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const selectedLabel =
    statusOptions.find((option) => option.value === formik?.values?.post_status)
      ?.label || "Select Status";

  const handleSelect = (value: string) => {
    formik.setFieldValue("post_status", value);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="agent-onboarding-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Status</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          placeholder="Select Status"
          className="filter-search-input"
          value={selectedLabel}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          readOnly
        />
        <div
          className={`filter-down-arrow-icon ${dropdownOpen ? "open-box" : ""}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <DownArrowIcon />
        </div>
      </div>

      {dropdownOpen && (
        <div className="review-list-container">
          {statusOptions.map((option) => (
            <div
              key={option.value}
              className={`agent-list-item ${
                formik.values.post_status === option.value
                  ? "agent-list-item-active"
                  : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <p className="item-profile-name">{option.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterStatusSelect;
